<template>
  <div class="container">
    <div class="boxtop">
      <van-nav-bar
        title="课程详情"
        class="fixedtop"
        left-arrow
        @click-left="goBackFn"
      />
    </div>
    <div class="top__details">
      <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
        @ready="playerReadied"
        @play="onPlayerPlay($event)"
        @pause="onplayerPause($event)"
        @timeupdate="onPlayerTimeupdate($event)"
      >
      </video-player>
      <div class="contest">
        <div class="title__bxs">
          <div class="detail__title t_text">
            {{ introduces.name }}
          </div>
          <div class="detai_down">
            <div class="ont_b">{{ introduces.class_hour }}课时</div>
            <div class="ont_b ont_a">课程时长：{{ introduces.min }}分钟</div>
            <div class="ont_b">
              截止日期：{{ introduces.expirationtime_mobile }}
            </div>
          </div>
        </div>
        <!-- 内容管理 -->
        <div class="cont_title" id="second">
          <p class="contjs">课程详情</p>
          <div class="listContent" v-html="content"></div>
        </div>
      </div>
      <div class="but__ton">
        <div class="butt_ox">
          <button
            class="jin_button"
            @click.stop="addPlan"
            :disabled="isDisable"
            v-if="is_join == 1"
          >
            加入学习计划
          </button>
          <button class="jin_button jin_color" v-else>已加入</button>
        </div>
      </div>
    </div>

    <!-- 认证失败弹窗 - 不可关闭 -->
    <div v-if="failModalVisible" class="auth-modal">
      <div class="auth-modal-content">
        <div class="auth-modal-header">
          <span class="auth-icon">⚠️</span>
          <span>认证失败</span>
        </div>
        <div class="auth-modal-body">
          <p>{{ failMessage }}</p>
          <p class="auth-tip">请重新认证</p>
        </div>
        <div class="auth-modal-footer">
          <button @click="retryAuth" class="auth-retry-btn">重新认证</button>
        </div>
      </div>
    </div>

    <!-- 需要认证弹窗 -->
    <div v-if="authModalVisible" class="auth-modal">
      <div class="auth-modal-content">
        <div class="auth-modal-header">
          <span class="auth-icon">⚠️</span>
          <span>需要认证才能继续</span>
        </div>
        <div class="auth-modal-body">
          <p>{{ failMessage }}</p>
          <p class="auth-tip">请前往认证</p>
        </div>
        <div class="auth-modal-footer">
          <button @click="goAuth" class="auth-retry-btn">去认证</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
export default {
  name: "detailsList",
  data() {
    return {
      id: '',
      is_join: 1,
      content: '2020二建协议护航班-包过不过退费2020二建协议护航班-包过不过退费2020二建协议护航班-包过不过退费2020二建协议护航班-包过不过退费',
      introduces: {},
      isDisable: false,
      videoImages: true,
      autoplay: false,

      // 视频标签

      playerOptions: {
        playbackRates: [1.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "",
          src: "" //url地址
        }],
        poster: "../../static/images/test.jpg", //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true  //全屏按钮
        }
      },

      gklog: 0, //视频观看时长
      duration: '',

      // ===== 实人认证相关 =====
      uid: 0,
      isNeedAuth: false,
      failModalVisible: false,
      failMessage: '',
      authModalVisible: false,
      authSysParam: null,
      authTimer: null,

      // ===== 视频进度上报相关 =====
      is_viewing: 0,
      change_view_time: 0,
      change_view_seconds: 10

    }
  },
  async created() {
    const routeParams = this.$route.query;
    this.id = routeParams.id
    let token = JSON.parse(window.localStorage.getItem('jin-token'))
    if (token) {
      await this.getUserUid()
      this.setSysParam()
    }

  },
  mounted() {
    // 定时轮询认证状态，超时需重新认证
    this.authTimer = setInterval(() => {
      if (!this.uid) return
      this.postFormRequest('api/user/checkauth', { uid: this.uid }).then(({ data }) => {
        if (data.code == 1 && data.data.needAuth) {
          this.changeAuth('authing')
          if (this.$refs.videoPlayer && this.$refs.videoPlayer.player) {
            this.$refs.videoPlayer.player.pause()
          }
          this.isNeedAuth = true
          this.showAuthModal()
        }
      })
    }, 1000 * 60)
    // 页面关闭时兜底上报观看状态与播放进度
    window.addEventListener('beforeunload', this.beforeunloadFn)
  },
  destroyed() {
    if (this.authTimer) {
      clearInterval(this.authTimer)
      this.authTimer = null
    }
    window.removeEventListener('beforeunload', this.beforeunloadFn)
    document.body.style.overflow = ''
  },
  methods: {

    // ===== 实人认证相关方法 =====
    // 获取用户ID（move项目未在store存储uid，此处从用户信息接口获取）
    async getUserUid() {
      try {
        const token = JSON.parse(localStorage.getItem('jin-token')) || ''
        const { data } = await this.postRequest('api/user/index', { token: token })
        if (data.code == 1 && data.data) {
          this.uid = data.data.id
        }
      } catch (err) {
        // 获取uid失败忽略，认证流程会在后续校验中提示
      }
    },
    // 拉取认证配置与状态
    setSysParam() {
      this.postFormRequest('api/user/authInfo', { uid: this.uid }).then(({ data }) => {
        if (data.code == 1) {
          this.authSysParam = data.data.auth
          const bio = this.authSysParam ? this.authSysParam.bio : ''
          if (bio == 'authsuccess') {
            // 已认证，加载视频
            this.isNeedAuth = false
            this.hideAuthModal()
            this.getIntroduces()
          } else if (bio == 'authfail') {
            this.isNeedAuth = true
            this.showFailModal('认证失败，请重新认证')
          } else {
            // 未认证（bio为空或authing），弹出认证弹窗
            this.isNeedAuth = true
            this.showAuthModal()
          }
        }
      })
    },
    // 修改认证状态
    changeAuth(auth = 'authing') {
      this.postFormRequest('api/user/changeAuth', { uid: this.uid, auth: auth })
    },
    // 去认证（拍照认证）
    goAuth() {
      this.pictureDeal()
    },
    // 重新认证
    retryAuth() {
      this.hideFailModal()
      this.pictureDeal()
    },
    // 跳转到拍照认证页面
    pictureDeal() {
      const urlParams = new URLSearchParams(window.location.search)
      let query = { page: 'study', uid: this.uid, id: this.id }
      for (const [key, value] of urlParams) {
        if (!query.hasOwnProperty(key)) {
          query[key] = value
        }
      }
      this.$router.push({ path: '/authCamera', query: query })
    },
    showAuthModal() {
      this.authModalVisible = true
      document.body.style.overflow = 'hidden'
    },
    hideAuthModal() {
      this.authModalVisible = false
      document.body.style.overflow = ''
    },
    showFailModal(message) {
      this.failMessage = message
      this.failModalVisible = true
      document.body.style.overflow = 'hidden'
    },
    hideFailModal() {
      this.failModalVisible = false
      this.failMessage = ''
      document.body.style.overflow = ''
    },

    /* 获取视频播放进度 */
    onPlayerTimeupdate(player) {
      this.gklog = player.cache_.currentTime
      var current
      // console.log(' onPlayerTimeupdate!', this.gklog)
      var last = localStorage.getItem('play_time' + this.$route.query.id);
      localStorage.setItem('duration' + this.$route.query.id, player.cache_.duration)
      localStorage.setItem('video_length' + this.$route.query.id, player.cache_.currentTime)
      current = player.cache_.currentTime
      if (current - last > 2) { //此处是限制跳过几秒 可调整
        player.currentTime(last);
      } else {
        last = player.cache_.currentTime
        localStorage.setItem('play_time' + this.$route.query.id, parseInt(player.cache_.currentTime))
      }
      // 定时上报观看中状态
      if (player.cache_.currentTime >= this.change_view_time) {
        this.change_view_status(1)
        this.change_view_time += this.change_view_seconds
      }
    },
    onPlayerPlay(player) {
      this.is_viewing = 1
      this.change_view_status(1)
    },
    onplayerPause(player) {
      // console.log(player);
      this.change_view_status(0)
      this.duration = player.cache_.currentTime
      this.Recordtheplay()
    },
    /* 设置视频进度 */
    playerReadied(player) {
      // console.log('我执行了');
      // console.log(this.gklog);
      player.currentTime(this.gklog)
    },
    goBackFn() {  // 回到上一步
      this.$router.go(-1);
    },
    richesHandle(data) {   // 富文本处理
      let fn_result = data
      fn_result = fn_result.replace(/()/g, "");
      fn_result = fn_result.replace(/(&nbsp;)/g, "");
      fn_result = fn_result.replace("<html><head><title></title></head><body>", "");
      fn_result = fn_result.replace("</body></html>", "")
      return fn_result;
    },
    async getIntroduces() {
      let that = this
      try {
        const { data: { data } } = await that.postRequest("api/user/video_detail", {
          id: that.id
        })
        // console.log(data);
        this.playerOptions['sources'][0]['src'] = data.video_file
        this.playerOptions['poster'] = data.video_image
        this.gklog = data.bofangtime
        // 定时上报起点 = 当前进度 + 10秒
        this.change_view_time = data.bofangtime + this.change_view_seconds
        // console.log(this.playerOptions['sources'][0]['src']);
        that.introduces = data
        that.content = data.content
        that.is_join = data.is_join

      } catch (err) {
        // console.log(err);
        Toast.fail(err.msg)
      }
    },
    async addPlan() {
      let that = this
      try {
        this.isDisable = true
        const { data } = await that.postRequest("api/user/join", {
          id: that.id
        })
        // console.log(data);
        if (data.code == 1) {
          Toast.success(data.msg)
          this.is_join = 2
          this.isDisable = false
        }
      } catch (err) {
        // console.log(err);
        Toast.fail(err.msg)
        this.isDisable = false
      }
    },
    async Recordtheplay() {
      let that = this
      try {
        this.isDisable = true
        const { data } = await that.postRequest("api/user/bofang", {
          id: that.id,
          duration: that.duration
        })
        // console.log(data);
        if (data.code == 1) {
          // Toast.success(data.msg)
        }
      } catch (err) {
        // console.log(err);
        Toast.fail(err.msg)
      }
    },
    // 上报观看状态（1=观看中 0=暂停/离开）
    change_view_status(e) {
      this.postRequest('api/user/change_view_status', {
        view_status: e,
        view_id: this.id
      }).then(({ data }) => {})
    },
    // 页面关闭时兜底上报（防止关闭页面导致进度/状态丢失）
    beforeunloadFn() {
      let token = JSON.parse(localStorage.getItem('jin-token')) || ''
      if (this.is_viewing) {
        this.sendBeacon('https://ht.tjjianan.com/api/user/change_view_status', {
          view_status: 0,
          view_id: this.id,
          token: token
        })
      }
      if (this.gklog) {
        this.sendBeacon('https://ht.tjjianan.com/api/user/bofang', {
          id: this.id,
          duration: this.gklog,
          token: token
        })
      }
    },
    // 使用 sendBeacon 发送兜底请求（页面卸载时仍能可靠送达）
    sendBeacon(url, param) {
      if (!navigator.sendBeacon) return
      let data = new FormData()
      for (let key in param) {
        if (param.hasOwnProperty(key)) {
          data.append(key, param[key])
        }
      }
      navigator.sendBeacon(url, data)
    },
    clickImgVideo() {
      this.videoImages = false
      this.openPlay();
      // console.log(this.autoplay);
    },
    openPlay() {
      let that = this
      that.autoplay = true
      this.$forceUpdate()
      // console.log(this.autoplay);
    },
    openPause() {
      this.autoplay = false
    },
  }
}
</script>

<style scoped lang='less'>
.container {
  width: 100%;
  min-height: 100%;
  background-color: #fff;
  position: relative;
  .boxtop {
    .fixedtop {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      background-color: #fff;
      z-index: 10;
    }
  }
  .top__details {
    margin-top: 60px;
    width: 100%;

    .video_box {
      width: 100%;
      height: 211px;
      position: relative;

      .video__mp4 {
        width: 100%;
        height: 211px;
      }

      .video__images {
        width: 100%;
        height: 211px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
      }
    }

    .contest {
      width: 100%;
      padding: 0 16px;
      box-sizing: border-box;

      .title__bxs {
        width: 100%;
        padding: 16px 0px;
        box-sizing: border-box;
        border-bottom: 1px solid #eeeeee;

        .detail__title {
          width: 100%;
          opacity: 1;
          font-size: 18px;
          font-family: PingFangSC-Medium;
          text-align: left;
          color: #06121e;
          font-weight: 600;
        }

        .detai_down {
          width: 100%;
          display: flex;
          align-items: center;
          padding-top: 16px;
          box-sizing: border-box;

          .ont_b {
            // flex: 1;
            padding: 0 17px;
            box-sizing: border-box;
            border-right: 1px solid #b4b1b2;
            opacity: 1;
            font-size: 12px;
            font-family: PingFangSC-Regular;
            text-align: left;
            color: #707070;
            letter-spacing: 0px;

            &:first-child {
              padding: 0 17px 0 0;
            }
            &:last-child {
              padding: 0 0 0 17px;
              border-right: 0 none;
              text-align: right;
            }
          }
        }
      }

      // 内容介绍
      .cont_title {
        padding: 16px 0;
        box-sizing: border-box;
        width: 100%;
        background-color: #fff;
        .contjs {
          font-size: 16px;
          font-family: PingFangSC-Medium;
          text-align: left;
          color: #06121e;
          line-height: 26px;
          font-weight: 600;
          position: relative;
          opacity: 1;

          &::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 65px;
            height: 10px;
            background-color: #d7ecff;
            opacity: 0.3;
          }
        }

        .listContent {
          width: 100%;
          margin-top: 16px;
        }
      }
    }

    .but__ton {
      width: 100%;
      position: fixed;
      bottom: 0px;
      left: 0;
      z-index: 10;

      .butt_ox {
        width: 100%;
        height: 52px;

        .jin_button {
          width: 100%;
          height: 52px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-size: 16px;
          background-color: #3e8bff;
        }

        .jin_color {
          background-color: #bdc4ce;
          color: #3e8bff;
        }

        button {
          padding: 0;
          margin: 0;
          border: 0 none;
        }
      }
    }
  }

  /* ========== 实人认证弹窗样式 ========== */
  .auth-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
  }

  .auth-modal-content {
    width: 80%;
    max-width: 320px;
    background-color: #fff;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
    animation: authModalFadeIn 0.2s ease-out;
  }

  @keyframes authModalFadeIn {
    from {
      opacity: 0;
      transform: scale(0.95);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  .auth-modal-header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 20px 16px 8px;
    font-size: 18px;
    font-weight: bold;
    color: #ff4d4f;
  }

  .auth-icon {
    font-size: 24px;
  }

  .auth-modal-body {
    padding: 16px 20px;
    text-align: center;
    color: #333;
    line-height: 1.5;

    p {
      margin: 0;
    }
  }

  .auth-tip {
    margin-top: 12px !important;
    font-size: 12px;
    color: #999;
  }

  .auth-modal-footer {
    padding: 16px 20px 24px;
    display: flex;
    justify-content: center;
  }

  .auth-retry-btn {
    border: none;
    border-radius: 30px;
    padding: 10px 0;
    width: 100%;
    font-size: 14px;
    font-weight: 500;
    background-color: #3e8bff;
    color: #fff;
  }
}
</style>
<style>
.listContent img {
  display: block;
  margin: 0 auto;
  max-width: 100% !important;
  height: auto !important;
}

.listContent p {
  max-width: 100%;
  word-break: break-all;
  font-size: 16px !important;
}

.listContent span {
  max-width: 100%;
  word-break: break-all;
  font-size: 16px !important;
}

table {
  max-width: 100%;
}
video {
  max-width: 100% !important;
}
</style>